<!-- <div class="form-group">
    <label for="" class="required">Número de teléfono</label>
    <input
      type="text"
      class="form-control"
    />
</div> -->
<div class="form-group">
  <label isRequired>Número de teléfono</label>
  <div class="flag-container" [ngClass]="{ 'is-invalid': !isValid }">
    <ng-select
      name="routes"
      style="width: 15rem;"
      [clearable]="false"
      [(ngModel)]="country"
      class="custom-dropdown"
      (change)="select($event)"
    >
      <ng-option *ngFor="let country of countries" [value]="country">
        <div class="opt">
          <div *ngIf="config.flag" [class]="'flags ' + country.FlagCssClass"></div>
          <span *ngIf="config.phoneCode">{{country.CountryPhoneCode}}</span>
          &nbsp; <span *ngIf="config.isoCode">{{country.ISOCode}}</span>
          &nbsp; <span *ngIf="config.name">{{country.name}}</span>
        </div>
      </ng-option>
    </ng-select>
    
    <input 
      [mask]="country?.InputMasking"
      (keyup)="inputValue($event.target.value)"
      [validation]="true"
      [dropSpecialCharacters]="false"
      [(ngModel)]="phone"
      [showMaskTyped]="true"
      class="form-control"
      type="text"
    >
  </div>
  <small class="text-danger" *ngIf="!isValid">
    Falta completar el número
  </small>
</div>

<div class="form-group" style="display: none;"><intl-input-phone #phoneinput [CountryList]="countries"></intl-input-phone></div>